export const fakeProps = <T extends object = object>(
  schemaData: any,
  defaults: T,
): typeof defaults => {
  let props = {};
  schemaData.fields.forEach((item) => {
    props[item.id] = typeData(item.type);
    switch (item.id) {
      case 'img':
        return (props[item.id] = '/assets/textimageplaceholder.png');
    }
  });
  props = { ...props, ...defaults };
  return props as T;
};

export const typeData = (type) => {
  switch (type) {
    case 'Array':
      return ['Item 1', 'Item 2', 'Item 3'];
    case 'Object':
      return { foo: 'bar' };
    case 'Boolean':
      return true;
    case 'Integer':
      return 42;
    case 'Number':
      return 3.14;
    case 'Link':
      return null; //link to asset
    case 'Date':
      return '2015-11-06T09:45:27';
    case 'Location':
      return { lat: 52.5208, lon: 13.4049 };
    case 'Symbol':
      return 'Example title or short text';
    case 'Text':
      return "In the world of coding and tests, where data reigns supreme, we use test data to do our best and make sure our code's a dream. We input names like Alice and Bob, and numbers like one and two, and with each test, we let out a sob, hoping our code will pull through. We create test data with such care, making sure each value's right, for if we don't, it's only fair that our code won't shine so bright. So here's to test data, our trusty friend, without which we'd be lost, for with it, our code we can defend, no matter the cost.";
  }
};

export default fakeProps;
